module.exports = __webpack_public_path__ + "static/howe-a5a4392bd4fbd928ae3817d65404544e.jpg";